export default "__VITE_ASSET__D44R6PAz__"